import { Link, useLocation } from 'react-router';
import type { PublicListingDto } from 'shared';
import { CoverImage } from '../../components/CoverImage.js';
import { formatPrice } from './ListingCard.js';

/**
 * What a map pin's popup shows when clicked — a small version of
 * `ListingCard`, not just the price/address text the map started with.
 * "See more details" is hidden when already on that listing's own detail
 * page (the single-pin map there), since pointing the link at the current
 * page would be a no-op.
 */
export function MapListingPopup({ listing }: { listing: PublicListingDto }) {
  const location = useLocation();
  const detailPath = `/listings/${listing.id}`;
  const specs = [`${listing.bedrooms} bd`, `${listing.bathrooms} ba`, listing.city || null].filter(
    Boolean,
  );

  return (
    <div className="map-popup">
      <CoverImage
        src={listing.photoUrl}
        alt={listing.addressLine1 || 'Rental listing'}
        variant="card"
      />
      <div className="map-popup__body">
        <p className="map-popup__price">${formatPrice(listing.price)}/month</p>
        {specs.length > 0 ? <p className="map-popup__specs">{specs.join(' | ')}</p> : null}
        {listing.addressLine1 ? <p className="map-popup__address">{listing.addressLine1}</p> : null}
        {location.pathname !== detailPath ? (
          <Link to={detailPath} className="map-popup__link">
            See more details →
          </Link>
        ) : null}
      </div>
    </div>
  );
}
